var _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _rect7, _rect8, _path3, _rect9, _rect0, _rect1, _rect10, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSanctionsCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 43,
    viewBox: "0 0 51 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.76766,
    y: 0.130544,
    width: 44.0077,
    height: 17.4464,
    rx: 3.78577,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.76766,
    y: 0.130544,
    width: 44.0077,
    height: 17.4464,
    rx: 3.78577,
    stroke: "white",
    strokeWidth: 0.261087
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8422,
    y: 6.42188,
    width: 6.26978,
    height: 5.22481,
    rx: 2.08993,
    fill: "#C3F3E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4336 8.74805L42.8669 9.31482L42.5268 8.97472",
    stroke: "#40DA9E",
    strokeWidth: 0.499846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9741 11.3781V11.3781C41.6755 11.3781 40.623 10.3256 40.623 9.02695V9.02695C40.623 7.72832 41.6755 6.67578 42.9741 6.67578V6.67578C44.2728 6.67578 45.3253 7.72832 45.3253 9.02695V9.02695C45.3253 10.3256 44.2728 11.3781 42.9741 11.3781Z",
    stroke: "#C3F3E1",
    strokeWidth: 0.391861,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0667,
    y: 4.83984,
    width: 8.5212,
    height: 2.27018,
    rx: 1.13509,
    fill: "#E3E7EE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0667,
    y: 9.52734,
    width: 16.3192,
    height: 2.27018,
    rx: 1.13509,
    fill: "#E3E7EE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.76775,
    y: 19.3102,
    width: 44.0077,
    height: 17.4464,
    rx: 3.78577,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.76775,
    y: 19.3102,
    width: 44.0077,
    height: 17.4464,
    rx: 3.78577,
    stroke: "white",
    strokeWidth: 0.261087
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8423,
    y: 25.0801,
    width: 6.2661,
    height: 5.22175,
    rx: 2.0887,
    fill: "#F48D53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2364 26.6465L42.4532 27.4297L43.4975 27.9519L42.7142 28.7352",
    stroke: "white",
    strokeWidth: 0.522175,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7552,
    y: 23.6035,
    width: 17.7075,
    height: 2.21344,
    rx: 1.10672,
    fill: "#E3E7EE"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7456,
    y: 27.5469,
    width: 20.8193,
    height: 2.34979,
    rx: 1.17489,
    transform: "rotate(-0.393915 14.7456 27.5469)",
    fill: "#E3E7EE"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    y: 11.0664,
    width: 31.2078,
    height: 31.2078,
    rx: 15.6039,
    fill: "#3158F2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.45364,
    y: 23.6367,
    width: 12,
    height: 8,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5013 32.1846V23.6647C21.5013 23.3364 21.2352 23.0703 20.9069 23.0703H18.2462",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5013 32.1846V23.6647C21.5013 23.3364 21.2352 23.0703 20.9069 23.0703H18.2462",
    stroke: "white",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0365 23.0703H10.3758C10.0475 23.0703 9.7814 23.3364 9.7814 23.6647V32.1846",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0365 23.0703H10.3758C10.0475 23.0703 9.7814 23.3364 9.7814 23.6647V32.1846",
    stroke: "white",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2462 25.0228H19.8738",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2462 26.9759H19.8738",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2462 28.929H19.8738",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4103 25.0228H13.0379",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4103 26.9759H13.0379",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4103 28.929H13.0379",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1521 32.1849H9.13168",
    stroke: "white",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0362 32.1852V21.1178C13.0362 20.7583 13.3276 20.4668 13.6872 20.4668H17.5933C17.9529 20.4668 18.2443 20.7583 18.2443 21.1178V32.1852",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0362 32.1852V21.1178C13.0362 20.7583 13.3276 20.4668 13.6872 20.4668H17.5933C17.9529 20.4668 18.2443 20.7583 18.2443 21.1178V32.1852",
    stroke: "white",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6651 26.9759H16.6181",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6651 28.929H16.6181",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6651 25.0228H16.6181",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6651 23.0697H16.6181",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6403 30.8828V32.1849",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanctionsCheckLarge);
export default __webpack_public_path__ + "static/media/sanctions_check_large.b0fea75ee1069d518a039a1767c1d5fc.svg";
export { ForwardRef as ReactComponent };